import { useEffect, useState, useMemo } from 'react'
import * as PropTypes from 'prop-types'
import { useTranslation } from 'react-i18next'

import { ELEVATEOS_LOGO_ALT } from '@/constants'

import Filter from '../../../../../../../components/Filter/Filter'
import Icon from '../../../../../../../components/Icons'
import { getIntegrationIcon } from '../../helpers'

const MergeUnitTypesForm = ({
  handleCancel,
  handleSubmit,
  checklistData,
  unitTypes,
  isSiteLoading,
  integrationLabel,
}) => {
  const { t } = useTranslation(['checklists-settings', 'common'])
  const availableUnitTypes = !!unitTypes.length
  const integrationIcon = getIntegrationIcon(integrationLabel)

  const convertForFullObjectOptions = (data) => {
    return [
      {
        id: 0,
        value: 'all',
        text: t('checklists-settings:mergeUnitTypesForm.allAvailableUnitTypesOption'),
        selectAll: true,
      },
      ...data.map((type, i) => {
        return { id: i + 1, value: type, text: type }
      }),
    ]
  }

  const [checklistUnitTypes, setChecklistUnitTypes] = useState([])

  const convertedAllavailableUnitTypes = useMemo(() => {
    if (unitTypes) {
      return convertForFullObjectOptions(unitTypes)
    }
    return []
  }, [unitTypes])

  useEffect(() => {
    if (checklistData && checklistData.activeUnitTypes) {
      setChecklistUnitTypes(
        convertedAllavailableUnitTypes.filter((typeObject) =>
          checklistData.activeUnitTypes.includes(typeObject.value),
        ),
      )
    }
  }, [convertedAllavailableUnitTypes])

  return (
    <div className="merge-unit-types-form">
      <div className={`merge-unit-types-form__container ${isSiteLoading ? 'is-disabled' : ''}`}>
        <div className="window-header">
          <div className="left-side">
            <div className="title">{t('checklists-settings:mergeUnitTypesForm.title')}</div>
          </div>
          <div className="right-side">
            <div className="navi-button" onClick={handleCancel}>
              <Icon icon="cross" />
            </div>
          </div>
        </div>
        <div className="main-view">
          <div className="instruction-header">
            {t('checklists-settings:mergeUnitTypesForm.instructionHeader', { integrationLabel })}
          </div>
          <div className="long-row">
            <div className="row">
              <span className="logo-icon-wrapper" style={{ marginRight: 20 }}>
                <img
                  width="40px"
                  height="40px"
                  src="/images/logo/elevateos-logo-square-black.png"
                  alt={ELEVATEOS_LOGO_ALT}
                />
              </span>{' '}
              {t('checklists-settings:mergeUnitTypesForm.elevateOsTypeLabel')}
            </div>
            <div className="row">
              {t('checklists-settings:mergeUnitTypesForm.integrationTypeLabel', {
                integrationLabel,
              })}{' '}
              {integrationIcon ? (
                <span className="logo-icon-wrapper" style={{ marginLeft: 20 }}>
                  <img
                    width="40px"
                    height="40px"
                    src={integrationIcon}
                    alt={t('checklists-settings:mergeUnitTypesForm.integrationIconAlt', {
                      icon: integrationIcon,
                    })}
                  />
                </span>
              ) : null}
            </div>
          </div>
          <div className="row">
            <div className="short-row">{checklistData.name}</div>
            <span className="icon-wrapper">
              <img src="/images/Arrows.jpg" />
            </span>
            {availableUnitTypes ? (
              <Filter
                placeholder={
                  checklistUnitTypes && checklistUnitTypes.length
                    ? convertedAllavailableUnitTypes
                        .filter((unitType) =>
                          checklistUnitTypes.map((x) => x.value).includes(unitType.value),
                        )
                        .map((t) => t.text)
                        .join(', ')
                    : t('checklists-settings:mergeUnitTypesForm.selectUnitTypePlaceholder')
                }
                options={convertedAllavailableUnitTypes}
                disabled={isSiteLoading}
                value={checklistUnitTypes || []}
                name={'unitTypesSelected'}
                additionalClass={'merge-unit-types-form__filter'}
                config={{ multiple: true }}
                variant={'rounded'}
                onChange={(e) => {
                  setChecklistUnitTypes(e.target.value)
                }}
              />
            ) : (
              <div className="short-row">
                {t('checklists-settings:mergeUnitTypesForm.allMatchedMessage')}
              </div>
            )}
          </div>
        </div>
        <div className="window-footer">
          <div className="footer-buttons">
            <button
              type="submit"
              className={`button button-gray is-block ${isSiteLoading ? 'is-loading' : ''}`}
              onClick={handleCancel}
              disabled={isSiteLoading}
            >
              {t('common:actions.cancel')}
            </button>
            <button
              type="submit"
              className={`button button-black is-block ${isSiteLoading ? 'is-loading' : ''}`}
              onClick={() => handleSubmit(checklistUnitTypes.map((type) => type.value))}
              disabled={isSiteLoading || !availableUnitTypes || !checklistUnitTypes.length}
            >
              {t('common:actions.save')}
            </button>
          </div>
        </div>
      </div>
    </div>
  )
}

MergeUnitTypesForm.propTypes = {
  handleCancel: PropTypes.func,
  handleSubmit: PropTypes.func,
  checklistData: PropTypes.object,
  unitTypes: PropTypes.array,
  isSiteLoading: PropTypes.bool,
  integrationLabel: PropTypes.string,
}

export default MergeUnitTypesForm
